import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";

import {Range} from "../utils/Range";
import {RewardModel} from "../reward/RewardModel";
import {Schema} from "@/common/Schema";

export class LevelConfig extends BaseObject {

    constructor() {
        super();

        this._level = 0;
        this._experience = null;
        this._energyCapacity = 0;
        this._reward = null;
    }

    get level() {
        return this._level;
    }

    set level(value) {
        this._level = value;
    }

    get experience() {
        return this._experience;
    }

    set experience(value) {
        this._experience = value;
    }

    get energyCapacity() {
        return this._energyCapacity;
    }

    set energyCapacity(value) {
        this._energyCapacity = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (!Number.isInteger(this.level) || this.level < 0) {
            return false;
        }

        if (this.experience && !this.experience.valid()) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new LevelConfig());
        } else if (target instanceof LevelConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(LevelConfig, {
    _uid: alias("uid", Schema.primitive()),
    _enabled: alias("enabled", Schema.primitive()),

    _level: alias("level", Schema.primitive()),
    _experience: alias("experience", Range.schema()),
    _energyCapacity: alias("energy_capacity", Schema.primitive()),
    _reward: alias("reward", RewardModel.schema()),
});